import React, { useState } from "react";
import SelecionarBusca from "../../components/SelecionarBusca";
import { Row, Col, Button, Form, Spinner } from "react-bootstrap";
import { FiltroCabecalho } from "../../components/FiltroCabecalho";

import { useToast } from "../../core/contexts/toast";
import { sazonalidadeContexto } from "../../core/contexts/sazonalidadeContexto";
import { useTranslation } from "react-i18next";
import { TipoTela } from "../../core/config/tipoTela";
import MonthRangePicker from "../../components/MonthRangePicker";
import { ModeloSopBusinessUnit } from "../../core/models/sopBusinessUnit";
import { ModeloSopProductFamily } from "../../core/models/sopProductFamily";
import { ModeloSopProduto } from "../../core/models/sopProduto";
import { ModeloSopRegion } from "../../core/models/sopRegion";
import { RepositorioSopBusinessUnit } from "../../core/repositories/sopBusinessUnitRepositorio";
import { RepositorioSopProductFamily } from "../../core/repositories/sopProductFamilyRepositorio";
import { RepositorioSopRegion } from "../../core/repositories/sopRegionRepositorio";
import { FiltroSopProduto, RepositorioSopProduto } from "../../core/repositories/sopProdutoRepositorio";
import { FiltroSopSales, RepositorioSopSales } from "../../core/repositories/sopSalesRepositorio";
import { useAutenticação } from "../../core/contexts/auth";
import { useModal } from "../../core/contexts/modalContexto";
import { BiCloudDownload } from "react-icons/bi";
import { tr } from "date-fns/locale";
import { RepositorioSopProduction } from "../../core/repositories/sopProductionRepositorio";
import { verificarSemanaAtual } from "../../core/utils/funcoes";
import { RepositorioSopInventory } from "../../core/repositories/sopInventoryRepositorio";

interface Props {
  titulo: string;
  filtro: FiltroSopSales;
  permissaoEditar: boolean;
  atualizarFiltro: (filtro: FiltroSopSales) => void;
  filtrarDados: (filtro: FiltroSopSales) => void;
  onSimulation: () => void;

}

export default function FiltroPI(props: Props) {
  const { t } = useTranslation();
  const { mostrarToast } = useToast();

  const { usuario } = useAutenticação();

  const [listaSopProduto, setListaSopProduto] = useState<ModeloSopProduto[]>([]);
  const [listaBusinessUnit, setListaBusinessUnit] = useState<ModeloSopBusinessUnit[]>([]);
  const [listaSopRegion, setListaSopRegion] = useState<ModeloSopRegion[]>([]);
  const [listaSopProductFamily, setListaSopProductFamily] = useState<ModeloSopProductFamily[]>([]);
  const [carregarBtnExportar, setCarregarBtnExportar] = useState(false);

  React.useEffect(() => {
    try {
      carregarSopProduto();
      carregaLista();
    } catch (error) {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    }
  }, []);


  async function SOP_PLAN() {
    setCarregarBtnExportar(true);
    try {

      var req = await new RepositorioSopSales().baixar(props.filtro)
      var blob = new Blob([req.data], {
        type: req.headers["content-type"],
      });
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `sales_${new Date().toISOString()}.xlsx`;
      link.click();

      req = await new RepositorioSopProduction().baixar(props.filtro)
      var blob = new Blob([req.data], {
        type: req.headers["content-type"],
      });
      link.href = window.URL.createObjectURL(blob);
      link.download = `production_${new Date().toISOString()}.xlsx`;
      link.click();

      req = await new RepositorioSopInventory().baixar(props.filtro)
      var blob = new Blob([req.data], {
        type: req.headers["content-type"],
      });
      link.href = window.URL.createObjectURL(blob);
      link.download = `inventory_${new Date().toISOString()}.xlsx`;
      link.click();
      

      setCarregarBtnExportar(false);

    } catch (error) {
      setCarregarBtnExportar(false);

      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    }


  }

  async function carregaLista() {
    try {
      setListaBusinessUnit(await new RepositorioSopBusinessUnit().getAll())
      setListaSopRegion(await new RepositorioSopRegion().getAll())
      setListaSopProductFamily(await new RepositorioSopProductFamily().getAll())

    } catch (error) {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    }
  }



  function carregarSopProduto() {
    props.filtro.cod_product = ""
    const filtroSopProduto = new FiltroSopProduto();
    filtroSopProduto.cod_product_family = props.filtro.cod_product_family;
    new RepositorioSopProduto().getFilter(filtroSopProduto).then((res) => {
      setListaSopProduto(res);
    }).catch((error) => {
      mostrarToast({
        titulo: t("pages.Erro!"),
        mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
        tipo: "error",
      });
    })
  }


  return (
    <div className="stick">
      <FiltroCabecalho
        titulo={props.titulo}
        filtro={props.filtro}
        atualizarFiltro={props.atualizarFiltro}
        lista={[]}
        tipoTela={TipoTela.SAZONALIDADE}
      >
        <>
          <Row className="row-cols-2 ">
            <Col md={2}>
              <MonthRangePicker
                startDate={props.filtro.dth_inicio}
                endDate={props.filtro.dth_fim}
                onRangeChange={(start, end) => {
                  props.filtro.dth_inicio = start;
                  props.filtro.dth_fim = end;
                  props.atualizarFiltro(props.filtro)
                }} />
            </Col>

            <Col md={2}>
              <SelecionarBusca
                titulo={t("Business Unit")}
                optionLabel="des_business_unit"
                optionValue="cod_business_unit"
                multiple
                value={props.filtro.cod_business_unit}
                options={listaBusinessUnit}
                onChange={(value) => {
                  props.filtro.cod_business_unit = value
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>

            {/* <Col md={2}>
              <SelecionarBusca
                titulo={t("Region")}
                optionLabel="des_region"
                optionValue="cod_region"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_region}
                options={listaSopRegion}
                onChange={(value) => {
                  props.filtro.cod_region = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col> */}

            <Col md={2}>
              <SelecionarBusca
                titulo={t("Product")}
                optionLabel="des_product"
                optionValue="cod_product"
                panelClassName="min-width-600"
                multiple
                logicaFiltroCodigo
                value={props.filtro.cod_product}
                options={listaSopProduto}
                onChange={(value) => {
                  props.filtro.cod_product = value;
                  props.atualizarFiltro(props.filtro)
                }}
              />
            </Col>

            <Col md={3} className="d-flex justify-content-end offset-md-3">
              <Form.Group as={Col} className="mb-2 valueComponent d-flex justify-content-end">
                <Button className="me-1 margin-top-24" variant="outline-primary" size="sm" onClick={() => props.atualizarFiltro(new FiltroSopSales())}              >
                  {t("pages.Limpar")}
                </Button>
              </Form.Group>


              <Form.Group as={Col} className="mb-2 valueComponent d-flex justify-content-end">
                <Button className="me-1 margin-top-24" variant="outline-primary" size="sm" onClick={() => props.onSimulation()}              >
                  {t("Simulation")}
                </Button>
              </Form.Group>

              <Form.Group as={Col} className="mb-2 valueComponent d-flex justify-content-end">
                <Button disabled={carregarBtnExportar} className="me-1 margin-top-24" variant="primary" size="sm" onClick={SOP_PLAN}              >
                  {carregarBtnExportar ?
                    <Spinner animation="border" size="sm" className="me-1" /> :
                    <BiCloudDownload className="me-1" />
                  }
                  {t("S&OP PLAN")}
                </Button>
              </Form.Group>
            </Col>
          </Row>
        </>
      </FiltroCabecalho>
    </div>
  );
}


